import { HttpTimeoutError } from '@cian/peperrors/shared';

import { chatsStateReceived, offerChatReceived } from 'shared/actions/chat/actionTypes';
import { ResponseError } from 'shared/errors/responseError';
import {
  TGetChatEnabledByOfferResponse,
  fetchGetChatEnabledByOffer,
} from 'shared/repositories/chats/v1/get-chat-enabled-by-offer';
import { getChatsOfferMarkup } from 'shared/repositories/chatsNotGenerated/v1/offer';
import { IApplicationContext } from 'shared/types/applicationContext';

import { IThunkActionCreator } from '../../store';

export function getChats(): IThunkActionCreator {
  return async (dispatch, getState, context) => {
    const state = getState();

    const {
      offer: { id: offerId },
      user,
    } = state.offerData;

    const [isOfferChatsEnabled, chatId] = await Promise.all([
      fetchOfferChatStatus(context, offerId),
      fetchOfferChat(context, offerId, !!user?.isAuthenticated),
    ]);

    dispatch(chatsStateReceived(isOfferChatsEnabled as boolean));

    if (!isOfferChatsEnabled || !chatId) {
      return;
    }

    return dispatch(offerChatReceived(chatId));
  };
}

async function fetchOfferChat(context: IApplicationContext, offerId: number, isAuthenticated: boolean) {
  if (!isAuthenticated) {
    return undefined;
  }

  const { telemetry, httpApi } = context;

  try {
    const { response } = await getChatsOfferMarkup(httpApi, { offerId });

    if ('chatId' in response) {
      return response.chatId;
    }
  } catch (error) {
    if (HttpTimeoutError.is(error)) {
      telemetry.increment('chats_timeout_offer_chat');
    }
  }

  return undefined;
}

async function fetchOfferChatStatus(context: IApplicationContext, offerId: number) {
  const { telemetry, httpApi, logger } = context;

  try {
    const { response, statusCode }: TGetChatEnabledByOfferResponse = await fetchGetChatEnabledByOffer({
      httpApi,
      parameters: { offerId },
    });

    if (statusCode === 400) {
      logger.warning(
        new ResponseError({
          domain: 'src/shared/services/chats/getChats.ts#fetchOfferChatStatus',
          message: response.message || 'Неизвестная ошибка',
          details: {
            // @ts-expect-error TODO: обновить swagger-generator
            error: response.errors,
          },
        }),
      );

      return false;
    }

    return response.enabled;
  } catch (error) {
    if (HttpTimeoutError.is(error)) {
      telemetry.increment('chats_timeout_offer_status');
    }

    return false;
  }
}
